// 简单的API前缀配置
export const API_PREFIXES = {
  AUTH: '/v1/auth',
  ADMIN: '/v1/admin',
  BACKYARD: '/backyard/v1',
};
